// Patch history BEFORE any router code loads
import './patchHistory';

import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/del-tokens.css';
import './styles/design-system.css';
import './styles/del-page-overlays.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import HealthCheckProvider from './contexts/HealthCheckContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HealthCheckProvider>
    <App />
  </HealthCheckProvider>
    
);

reportWebVitals();
